import axios from 'axios';
import { API_BASE_URL, ENDPOINTS } from '../config';

axios.defaults.headers.post['Content-Type'] = 'application/json';
const API_URL = `${API_BASE_URL}${ENDPOINTS.LOGIN}`;

export const login = async (login, password) => {
  try {
    const response = await axios.post(API_URL, { login, password });
    
    if (response.data.code === 200) {
      localStorage.setItem('token', response.data.response[0].token);
      localStorage.setItem('username', response.data.response[0].login);
      return { success: true, message: response.data.message };
    }
    return { success: false, message: response.data.message };
  } catch (error) {
    return { 
      success: false, 
      message: error.response?.data?.message || 'Login failed',
      error: error.response?.data
    };
  }
};

export const isAuthenticated = () => {
    return !!localStorage.getItem('token');
};

export const logout = () => {
    localStorage.removeItem('token');
};